import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "article",
  "use": "article-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"article\"><g fill-rule=\"evenodd\"><path d=\"M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm-3.5-5H14v-1H6v1h.5Zm0 2H14v-1H6v1h.5Zm5.833-6H14V7h-2v1h.333Zm0 2H14V9h-2v1h.333Z\" /><path d=\"m7.185 9-.543 1H5.5l3-5.5 3 5.5h-1.145l-.542-1H7.185Zm.543-1L8.5 6.58 9.27 8H7.728Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol